module.exports = __webpack_public_path__ + "static/media/Discovery-BM.5fb288b6.svg";